import React, { useContext,useEffect } from 'react';
import { Box } from '@mui/material';
import { UPLOADS } from '../constants';
import { FormContext } from '../FormContext/FormContext';
import { useCheckIsMobile } from '../Hooks/UseCheckIsMobile';
import DocumentUpload from '../Components/DocumentUpload';

const UploadDocument = () => {
  const [values,setErrorMsg,,canContinue,  setCanContinue] = useContext(FormContext);
  const dropzoneOrientation = useCheckIsMobile() ? 'column' : 'row';
   const uploadsErrors = setErrorMsg('uploads', ['noSupplement', 'invalidSupplement']);
    const oneValidFile = values.uploads.files.some((file) => file.category === 'estimate');
  

  
 useEffect(() => {
values.activeStep === 2 && setCanContinue(oneValidFile);
}, [oneValidFile,setCanContinue,canContinue]);
  
 

  return (
    <Box style={{ padding: '20px', maxWidth: '665px' }}>
      <Box
        alignItems='center'
        flexDirection={dropzoneOrientation}
        justifyContent='center'
      >
          {values.activeStep === 2 &&
          <DocumentUpload
            category={UPLOADS.ESTIMATE.CATEGORY}
            heading={UPLOADS.ESTIMATE.HEADING}
            subHeading={UPLOADS.ESTIMATE.SUB_HEADING}
            text={UPLOADS.ESTIMATE.TEXT}
            hasError={Array.isArray(uploadsErrors) && uploadsErrors.length > 0}
          />}
          {values.activeStep === 3 &&
          <DocumentUpload
            category={UPLOADS.PHOTOS.CATEGORY}
            heading={UPLOADS.PHOTOS.HEADING}
            subHeading={UPLOADS.PHOTOS.SUB_HEADING}
            text={UPLOADS.PHOTOS.TEXT}
            hasError={Array.isArray(uploadsErrors) && uploadsErrors.length > 0}
          />}           
       
        
      </Box>
      
    </Box>
  );
};

export default UploadDocument;
